module.exports = __webpack_public_path__ + "static/media/sponsored-prizes.73a5433d.png";